import { ResizeService } from 'services/ResizeService'
import { signal } from 'services/SignalsService'

const name = 'BUILD-SPLASH'

async function execute() {
  game.application.makeSplash(onEnd)

  function onEnd() {
    ResizeService.resize()
    signal.dispatch('LOGO-ANIM:DONE')
    return Promise.resolve()
  }
}

export function getBuildSplashAction() {
  return {
    name,
    execute,
  }
}
